<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    placeholder: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    onChange(e) {
      this.$emit('input', e.target.value);
    },
    onBlur(e) {
      this.$emit('blur', e.target.value);
    },
  },
};
</script>

<template>
  <label class="input-container">
    <span v-if="label">{{ label }}</span>
    <!-- Sem classe de cor aqui: o estilo do campo vive em widgets/_base.scss,
         que ja alcanca todo input do app. Repetir `bg-surface`
         neste componente era o que fazia o primitivo carregar o visual antigo
         mesmo depois de a base ser padronizada. -->
    <input
      :value="value"
      :type="type"
      :placeholder="placeholder"
      :readonly="readonly"
      :style="styles"
      @input="onChange"
      @blur="onBlur"
    />
    <p v-if="helpText" class="help-text">{{ helpText }}</p>
    <span v-if="error" class="message">
      {{ error }}
    </span>
    <slot name="masked" />
  </label>
</template>

<style scoped lang="scss">
// Quem e dono do espacamento e a raiz, nao o campo.
//
// A raiz deste componente e o <label>, entao `class="!mb-0"` escrito pela tela
// cai nele -- e nao no <input>, que carrega `mb-4` proprio de widgets/_base.scss.
// Resultado: 20 telas pedem para colar o campo no vizinho e nada acontece. Numa
// linha `items-center` quem e centrada e a caixa de MARGEM, entao o campo
// desenhava 8px acima do centro, ao lado de um botao da mesma altura.
//
// O mesmo `mb-4` tambem abria 18px entre o campo e o seu proprio texto de ajuda,
// que deveria ficar colado.
//
// Passando a margem para o container os dois somem, e o utilitario do chamador
// finalmente alcanca o que ele achava que estava alcancando. O espaco total
// abaixo do campo vai de 20px (16 do input + 4 do label) para 16px.
//
// `:not(.reset-base)` nao e enfeite: sem ele o seletor fica em (0,1,1) e perde
// para `input[type='text']:not(.reset-base)` (0,2,1) da base. Com ele empata em
// especificidade e o atributo do `scoped` desempata a favor daqui.
.input-container {
  @apply block mb-4;

  > input:not(.reset-base) {
    @apply mb-0;
  }
}

.help-text {
  @apply mt-0.5 text-xs not-italic text-muted dark:text-muted;
}

.message {
  margin-top: 0 !important;
}
</style>
